import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import DoctorContactsNew from "./DoctorContactsNew";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import SelectedDoctorsNew from "./SelectedDoctorNew";
import DoctorContext from "../../ClinicWrapper/DoctorContext";
import DoctorSearchbar from "../../ClinicWrapper/DoctorSearchbar";
import crossIcon from "../../../../assets/crossIcon.svg";
import { addQuery } from "../../../MyTransactionsView/helper";
import { useHistory, useLocation } from "react-router-dom";
import {
  API_FILTER_LIST,
  DEFAULT_TRANSACTIONS_PAYLOAD,
} from "../../../MyTransactionsView/constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";
import { useCookies } from "react-cookie";
import { setDynamicCookieForUser } from "../../../../Util/API Calls/cookieHelper";

const AllDoctorsContent = (props) => {
  const { show, onHide } = props;

  let history = useHistory();
  let location = useLocation();
  const doctor_context = useContext(DoctorContext);
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [selectedDoctorsDup, setselectedDoctorsDup] = useState([]);
  const [filteredDoctors, setfilteredDoctors] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const [cookies, setCookie] = useCookies(["cookie-name"]);

  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  const onSubmit = (event) => {
    setSearchValue(event["search_string"]);
  };

  const onClearData = () => {
    setSearchValue("");
  };

  useEffect(() => {
    const filteredDoctor = doctor_context.doctorList.filter(
      (doctor) =>
        localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) !==
          USER_ROLE.RESOURCE_ADMIN || doctor.is_resource === "True"
    );

    setDoctors(filteredDoctor);

    const selectedFromFiltered = filteredDoctor.filter(
      (doctor) => doctor.selected === true
    );

    if (filteredDoctor.length > 0) {
      setSelectedDoctors(selectedFromFiltered);
    } else {
      setSelectedDoctors([]);
    }
    setselectedDoctorsDup(filteredDoctor);
  }, [doctor_context.selectedDoctor, doctor_context.doctorList]);

  useEffect(() => {
    setfilteredDoctors(
      doctors
        .filter((doctor) => {
          return (
            doctor?.name?.toLowerCase().includes(searchValue?.toLowerCase()) || //searcheddoct
            doctor?.doctor_phone_no?.includes(searchValue) //searchedPatient
          );
        })
        .sort((a, b) => {
          const firstNameA = a.doctor_first_name
            ? a.doctor_first_name.trim()
            : "" + a.doctor_middle_name
            ? " " + a.doctor_middle_name.trim()
            : "" + a.doctor_last_name
            ? " " + a.doctor_last_name.trim()
            : "";
          const firstNameB = b.doctor_first_name
            ? b.doctor_first_name.trim()
            : "" + b.doctor_middle_name
            ? " " + b.doctor_middle_name.trim()
            : "" + b.doctor_last_name
            ? " " + b.doctor_last_name.trim()
            : "";

          return firstNameA.localeCompare(firstNameB);
        })
    );
  }, [searchValue, doctors]); //searchedPatient

  const handleCheckDoctorContacts = (event) => {
    let allDoctors = [...doctors];
    let allSelectedDoctors = [...selectedDoctors];

    allDoctors.forEach((doc) => {
      if (doc.id === event?.target?.value) {
        doc.selected = event?.target?.checked;
        if (event?.target?.checked) {
          if (!allSelectedDoctors.some((ps) => ps?.id === doc?.id)) {
            allSelectedDoctors.push(doc);
          }
        } else {
          if (allSelectedDoctors.some((ps) => ps?.id === doc?.id)) {
            allSelectedDoctors = allSelectedDoctors?.filter(
              (ps) => ps?.id !== doc?.id
            );
          }
        }
      }
    });

    if (allSelectedDoctors?.length < doctors?.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (
      allSelectedDoctors?.length === doctors?.length &&
      checkedAll === false
    ) {
      setCheckedAll(true);
    }
    setSelectedDoctors(allSelectedDoctors);
    setDoctors(allDoctors);
  };

  useEffect(() => {
    if (
      filteredDoctors?.length > 0 &&
      selectedDoctors?.length > 0 &&
      filteredDoctors?.length === selectedDoctors?.length
    )
      setCheckedAll(true);
  }, [show, filteredDoctors]);

  const removeSelectedDoctors = (index) => {
    let allSelectedDoctors = [...selectedDoctors];
    let allDoctors = [...doctors];
    allSelectedDoctors = allSelectedDoctors?.filter((ps) => ps?.id !== index);
    for (let i = 0; i < allDoctors?.length; i++) {
      if (allDoctors[i].id === index) {
        allDoctors[i].selected = false;
      }
    }
    if (allSelectedDoctors?.length < doctors?.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setSelectedDoctors(allSelectedDoctors);
    setDoctors(allDoctors);
  };

  const handleCheckAllDoctors = (event) => {
    let allDoctors = [...doctors];
    let allSelectedDoctors = [...selectedDoctors];
    setCheckedAll(event?.target?.checked);
    allDoctors &&
      allDoctors.forEach((p) => {
        p.selected = event.target.checked;
        if (event?.target?.checked) {
          if (!allSelectedDoctors?.some((ps) => ps?.id === p?.id)) {
            allSelectedDoctors.push(p);
          }
        } else {
          if (allSelectedDoctors?.some((ps) => ps?.id === p?.id)) {
            allSelectedDoctors = allSelectedDoctors.filter(
              (ps) => ps?.id !== p?.id
            );
          }
        }
      });
    setSelectedDoctors(allSelectedDoctors);
    setDoctors(allDoctors);
  };

  const handleSelectedDoctor = () => {
    doctor_context.setSelectedDoctor(selectedDoctors);
    localStorage.setItem("selectedDoctor", JSON.stringify(selectedDoctors));
    let selectedDoctorArr = [];
    selectedDoctorArr = JSON.parse(
      localStorage.getItem(LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS)
    );

    if (selectedDoctorArr?.length === 0) {
      selectedDoctorArr = [];
    }
    let foundIndex = selectedDoctorArr?.findIndex(
      (doctor) => doctor?.clinic_id === clinicId
    );
    if (foundIndex > -1) {
      selectedDoctorArr[foundIndex] = {
        clinic_id: clinicId,
        doctors: selectedDoctors,
      };
      // console.log(" ----> b2", selectedDoctorArr);
      localStorage.setItem(
        LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
        JSON.stringify(selectedDoctorArr)
      );
      setDynamicCookieForUser(
        LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
        JSON.stringify(selectedDoctorArr),
        setCookie
      );
    } else {
      selectedDoctorArr = selectedDoctorArr || [];
      selectedDoctorArr.push({
        clinic_id: clinicId,
        doctors: selectedDoctors,
      });

      localStorage.setItem(
        LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
        JSON.stringify(selectedDoctorArr)
      );
      setDynamicCookieForUser(
        LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS,
        JSON.stringify(selectedDoctorArr),
        setCookie
      );
    }
    if (
      JSON.stringify(selectedDoctors) !== JSON.stringify(selectedDoctorsDup)
    ) {
      localStorage.removeItem("staff_selected_dr");
    }

    if (history?.location?.pathname?.includes("mytransactions")) {
      addQuery(
        history,
        location,
        [API_FILTER_LIST.PAGENO],
        [DEFAULT_TRANSACTIONS_PAYLOAD.page_no]
      );
    }
    onHide();
  };

  return (
    <>
      <div className="dm-heading d-flex justify-content-between">
        <p className="dm-heading-text">Select Doctor Accounts</p>
        <span className="float-right cursor-pointer" onClick={onHide}>
          <img
            src={crossIcon}
            style={{ cursor: "pointer" }}
            alt="crossIcon"
          ></img>
        </span>
      </div>
      <>
        <div className="list-drawer">
          <div className="px-0 pb-1">
            <div className="">
              <>
                <DoctorSearchbar
                  onChange={(e) =>
                    onSubmit({ search_string: e?.target?.value?.trim() })
                  }
                  inputText={searchValue}
                  clearData={onClearData}
                  placeholder={"Search for Account Name or Mobile No."}
                />
                {selectedDoctors?.length > 0 ? (
                  <div className="px-4 my-3">
                    <div
                      className="selected-contacts py-2 boder-0 " //slug-contact-list
                      style={{ overflow: "auto", overflowY: "hidden" }}
                    >
                      {selectedDoctors?.map((sp) => (
                        <SelectedDoctorsNew
                          key={sp.id}
                          {...sp}
                          removeSelectedDoctors={removeSelectedDoctors}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className={"total-dr"}>
                  <p className="m-0 px-4 mt-3 p-1 total-dr-heading">
                    Total Doctors ({filteredDoctors?.length})
                  </p>
                </div>
                <div className="px-4 contact-container">
                  <input
                    id={"select-all"}
                    type={"checkbox"}
                    className={"d-none"}
                    checked={checkedAll}
                    onChange={handleCheckAllDoctors}
                  />
                  <div className="d-flex my-3">
                    <label
                      htmlFor={"select-all"}
                      className="no-image m-0 mr-3 cursor-pointer"
                    >
                      <p className="initials m-0">
                        {checkedAll ? <CheckOutlinedIcon /> : "All"}
                      </p>
                    </label>
                    <label
                      htmlFor={"select-all"}
                      className={"d-flex align-items-center m-0 cursor-pointer"}
                    >
                      <p className="m-0 " style={{ color: "#17BAE0" }}>
                        {checkedAll ? "Remove All" : "Select All"}
                      </p>
                    </label>
                  </div>
                </div>

                {filteredDoctors?.length > 0 ? (
                  <div
                    className="px-4 contact-list pb-1 container_scroll doctor_list_view"
                    style={{
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {filteredDoctors?.map((doctor, index) => (
                      <DoctorContactsNew
                        key={doctor.id}
                        {...doctor}
                        handleCheckDoctorContacts={handleCheckDoctorContacts}
                      />
                    ))}
                  </div>
                ) : (
                  <>
                    <p className="text-center text-danger">No Doctor Found</p>
                  </>
                )}
              </>
            </div>
          </div>
          <div className="d-flex justify-content-center my-2 doctor_submit_btn">
            <button
              type="button"
              className="btn border share-button rounded-pill  mt-1 mb-1 px-4"
              style={{ width: "150px", height: "50px" }}
              onClick={handleSelectedDoctor}
              disabled={selectedDoctors?.length > 0 ? false : true}
            >
              Select
            </button>
          </div>
        </div>
      </>
    </>
  );
};
export default AllDoctorsContent;
